<template>
  <div class="content">
    <div class="two" v-if="list.length>1">
      <div class="tit">您是否想了解以下楼盘</div>
      <div v-for="(item,index) in list" :key="index" class="tit2" >
        {{ item.name }}楼盘 {{ item.address }} <span v-html="'\u00a0\u00a0'"></span>最高补贴<span class="red">{{item.subsidyEnd}}</span>元
      </div>
    </div>
    <div class="one" v-else>
    <div class="tit">预计最高可领</div>
    <div class="tit2"><span class="red">{{price}}</span>元</div>
    </div>

    <div class="right_tit">
      <div class="btn" @click="gologin">立即注册领取</div>
      <div class="btn" @click="dowload">下载了解更多</div>
    </div>
  </div>
</template>

<script>
import { uploadimg } from "@/api/ajax.js";
import {
  clos_encryptDes,
  clos_encryptDes1,
  clos_encryptDes2,
  clos_encryptDesForApp,
  time as initTime,
} from "@/encryption";
import {Toast} from "vant";
import {properties} from "api/ajax";
export default {
  name: "Advertise",
  data() {
    return {
      name:'',//楼盘名字
      list:[],
      price:''
    };
  },
  computed: {

  },
  mounted() {
this.submit()
  },
  methods: {
    //立即注册并领取
    gologin(){
      this.$router.push({ path: "./godownload"})
    },
    //下载了解更多
    dowload(){
window.open('https://apps.apple.com/cn/app/%E6%88%BF%E5%93%81%E4%BC%98%E9%80%89-%E9%80%89%E6%88%BF%E4%B9%B0%E6%88%BF%E5%AE%89%E5%AE%B6%E6%8B%BF%E8%A1%A5%E8%B4%B4%E7%9A%84%E6%96%B0%E6%88%BF%E5%B9%B3%E5%8F%B0/id1492786478')
//       window.location.href="https://apps.apple.com/cn/app/%E6%88%BF%E5%93%81%E4%BC%98%E9%80%89-%E9%80%89%E6%88%BF%E4%B9%B0%E6%88%BF%E5%AE%89%E5%AE%B6%E6%8B%BF%E8%A1%A5%E8%B4%B4%E7%9A%84%E6%96%B0%E6%88%BF%E5%B9%B3%E5%8F%B0/id1492786478"
    },


    async submit() {
      console.log(this.$route.query.key,'9090')
      this.name=this.$route.query.key
      if(this.name==''){
        Toast.fail('楼盘名称不能为空');
        // return false
        this.$router.push({ path: "./properties"})
      }
      let time = this.time()
      let args = {
        action: "account.getHouseInfoForExtend",
        verifyCode:this.code,//验证码
        phoneNumber:this.phone,//电话
        timestamp:time,
        name:this.name,
      };
      properties(args). then(res=>{
        console.log(res.data,'9999')
        if(res.data.length>1){
          this.list=res.data
        }else{
          this.price=res.data[0].subsidyEnd
        }

      }). catch(error=>{
// console.log(error.errorMessage,'是嘛')
        Toast.fail(error.errorMessage);
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.content{
  position: relative;
  padding: 16px;
  .one{
    .tit{
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      text-align: left;
      height: 80px;
      line-height: 80px;
    }
    .tit2{
      font-size: 20px;
      //font-weight: bold;
      color: #333333;
      text-align: center;
      height: 50px;
      line-height: 40px;
      font-weight: bold;
      .red{
        color: rgb(214,6,31);
        font-size: 26px;
        font-weight: bold;
      }
    }
  }
  .two{
    .tit{
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      text-align: left;
      height: 80px;
      line-height: 80px;
    }
    .tit2{
      font-size: 14px;
      font-weight: bold;
      color: #333333;
      text-align: left;
      height: 50px;
      line-height: 28px;

      word-break: break-all;
      word-wrap: break-word;

      .red{
        color: rgb(214,6,31);
        font-size:14px;
      }
    }
  }

  .right_tit{
    font-size: 14px;
    font-weight: 600;
    color: #444;
    line-height: 20px;
    padding: 40px 0;
    display: flex;
    justify-content: space-around;
    .btn{
      width:120px;
      //margin: 25px auto 5px;
      color: white;
      text-align: center;
      height: 40px;
      border-radius: 6px;
      line-height: 40px;
      background-color:rgb(19,152,209);
      font-size: 14px;
      margin-top: 17px;
    }
  }

}
</style>